import { AfterContentInit, Component, Input, OnDestroy } from '@angular/core';
import { EducationStepInterface } from '../../models/interfaces/education-step.interface';
import { PrettyLineService } from '../../services/pretty-line.service';
import { environment } from 'src/environments/environment';
import { EducationProgressTypeEnum } from '../../models/enums/education-progress.enum';
import { BasicContentBlockComponent } from '../blocks/basic-content-block/basic-content-block.component';
import { OepApiService } from '../../services/oep-api.service';
import { IomModuleService } from '../../services/iom-module.service';
import { BehaviorSubject, catchError, finalize, of, Subject, take, takeUntil } from 'rxjs';
import { OnInit } from '@angular/core';
import { DeviceType } from '../../models/interfaces/device-type.type';
import { DeviceWidthService } from '../../services/width.service';
import { NavigationCardComponent } from '../navigation-card/navigation-card.component';
import { NavigationCardDopoComponent } from '../navigation-card-dopo/navigation-card-dopo.component';
import { RouterLink } from '@angular/router';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgFor, NgClass, NgIf, AsyncPipe } from '@angular/common';
import { StepperComponent } from '../stepper/stepper.component';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    host: {
        class: 'navigation'
    },
    standalone: true,
    imports: [StepperComponent, NgFor, CdkStepperModule, NgClass, RouterLink, NgIf, NavigationCardDopoComponent, NavigationCardComponent, AsyncPipe]
})
export class NavigationComponent extends BasicContentBlockComponent implements OnDestroy, AfterContentInit, OnInit {

  icons: BehaviorSubject<string | undefined>[] = [];
  deviceType: DeviceType = 'desktop';
  private destroy$ = new Subject<void>();

  get isParacelsus(): boolean {
    return environment.style === 'paracelsus';
  }

  get isDopo(): boolean {
    return false
  }

  get progressTypeEnum () {
    return EducationProgressTypeEnum;
  }

  @Input()
  educationalSteps: EducationStepInterface[] | undefined;

  constructor(
    private readonly prettyLineService: PrettyLineService,
    private readonly oep: OepApiService,
    private deviceWidth: DeviceWidthService
  ) {
    super();
  }

  override ngOnInit() {
    this.deviceWidth.getDeviceType$()
    .pipe(takeUntil(this.destroy$))
    .subscribe(type => {
      this.deviceType = type;
    });
  }

  ngAfterContentInit(): void {
    if (!this.educationalSteps) {
      return;
    }
    this.icons = this.educationalSteps.map(() => new BehaviorSubject<string | undefined>(undefined));

    this.educationalSteps.forEach((step, index) => {
      if (
        step.icon &&
        step.icon.id &&
        step.icon.content &&
        step.icon.content.fileId
      ) {
        this.oep
          .loadIcon(step.icon.id, step.icon.content.fileId)
          .pipe(
            take(1),
            catchError((error) => {
              console.error(`Error loading icon for step ${index}:`, error);
              return of(null);
            }),
            finalize(() => {
            })
          )
          .subscribe((blob) => {
            if (blob && blob.file) {
              const file = 'data:' + blob.MIME + ';base64, ' + blob.file;
              this.icons[index].next(file);
            } else {
              this.icons[index].next(undefined);
            }
          });
      } else {
        this.icons[index].next(undefined);
      }
    });
  }

  ngOnDestroy(): void {
    this.prettyLineService.clearLine();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
